type FormatDateReturnType = string;

const dateFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export const formatDate = (date: string): FormatDateReturnType => {
  const dateObject = new Date(date);
  if (isNaN(dateObject.getTime())) {
    return 'Invalid date';
  }

  return dateFormatter.format(dateObject);
};
